import { useState, useCallback } from "react";

/**
 * 统一管理 BotControl 中 5 个模态框的开关状态
 */
export function useBotModals() {
  const [isCreateVisible, setIsCreateVisible] = useState(false);
  const [isManageVisible, setIsManageVisible] = useState(false);
  const [isControlVisible, setIsControlVisible] = useState(false);
  const [isLogsVisible, setIsLogsVisible] = useState(false);
  const [isChatsVisible, setIsChatsVisible] = useState(false);
  const [selectedBot, setSelectedBot] = useState(null);

  const openCreate = useCallback(() => {
    setIsCreateVisible(true);
  }, []);

  const closeCreate = useCallback(() => {
    setIsCreateVisible(false);
  }, []);

  const openManage = useCallback((bot) => {
    setSelectedBot(bot);
    setIsManageVisible(true);
  }, []);

  const closeManage = useCallback(() => {
    setIsManageVisible(false);
  }, []);

  const openControl = useCallback(() => {
    setIsManageVisible(false);
    setIsControlVisible(true);
  }, []);

  const closeControl = useCallback(() => {
    setIsControlVisible(false);
  }, []);

  const openLogs = useCallback(() => {
    setIsManageVisible(false);
    setIsLogsVisible(true);
  }, []);

  const closeLogs = useCallback(() => {
    setIsLogsVisible(false);
  }, []);

  const openChats = useCallback(() => {
    setIsManageVisible(false);
    setIsChatsVisible(true);
  }, []);

  const closeChats = useCallback(() => {
    setIsChatsVisible(false);
  }, []);

  const closeAll = useCallback(() => {
    setIsCreateVisible(false);
    setIsManageVisible(false);
    setIsControlVisible(false);
    setIsLogsVisible(false);
    setIsChatsVisible(false);
    setSelectedBot(null);
  }, []);

  return {
    // 状态
    isCreateVisible,
    isManageVisible,
    isControlVisible,
    isLogsVisible,
    isChatsVisible,
    selectedBot,
    // 打开方法
    openCreate,
    openManage,
    openControl,
    openLogs,
    openChats,
    // 关闭方法
    closeCreate,
    closeManage,
    closeControl,
    closeLogs,
    closeChats,
    closeAll,
  };
}
